import { render, staticRenderFns } from "./BoxedArrowUpIcon.vue?vue&type=template&id=35dabeb1&scoped=true&"
var script = {}
import style0 from "./BoxedArrowUpIcon.vue?vue&type=style&index=0&id=35dabeb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dabeb1",
  null
  
)

export default component.exports